import React, { Component } from "react"
import LoginForm from "../login/loginForm"
import { AFTER_LOGIN_DEFAULT_LANDING } from "../../../constants"
import { withRouter, Redirect } from "react-router-dom"
import MetaTags from "../../elements/meta/metaTags.js"
import { trackViewLoginForm } from "../../elements/tracking/loginTracking.js"
import { Container } from "components/elements"

class LoginPage extends Component {
  //Figure out the redirect stuff.
  constructor() {
    super()
    this.state = {
      redirectToReferrer: false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    trackViewLoginForm({ login_type: "Modal" })
  }

  handleLogin = () => {
    if (this.props.location.hasOwnProperty("state")) {
      if (this.props.location.state !== undefined) {
        if (this.props.location.state.from !== undefined) {
          const { from } = this.props.location.state
          this.props.history.push({
            pathname: from.pathname,
            state: from.state
          })
        }
      } else {
        this.props.history.push(AFTER_LOGIN_DEFAULT_LANDING)
      }
    } else {
      this.props.history.push(AFTER_LOGIN_DEFAULT_LANDING)
    }
  }
  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } } // this looks funky
    const { redirectToReferrer } = this.state

    if (redirectToReferrer === true) {
      return <Redirect to={from} />
    }

    return (
      <Container className="extra-extra-small">
        <MetaTags
          title={"Login or Signup"}
          url={this.props.location.pathname}
          type="company"
        />
        <LoginForm
          showBottomLinks={true}
          container="page"
          onSuccess={this.handleLogin}
          parentDescription={"Login Page"}
        />
      </Container>
    )
  }
}
export default withRouter(LoginPage)
